module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_03-33b0e72cf59c0cebb45a097f2d979a02.jpg";